"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _HoverTracker = _interopRequireDefault(require("./HoverTracker"));

/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2020
 */
var BaseAnalytic = /*#__PURE__*/function () {
  function BaseAnalytic(analyticsId, secretId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck2["default"])(this, BaseAnalytic);

    if ((0, _typeof2["default"])(secretId) === "object") {
      options = secretId;
      secretId = null;
    }

    this.setDebug(options.debug);
    this.analyticsId = analyticsId;
    this.secretId = secretId;
    this.setup(analyticsId, secretId);
  }

  (0, _createClass2["default"])(BaseAnalytic, [{
    key: "setup",
    value: function setup(analyticsId, secretId) {}
  }, {
    key: "trackPageView",
    value: function () {
      var _trackPageView = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var props,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                props = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                _context.next = 3;
                return this.trackEvent("page_view", props);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function trackPageView() {
        return _trackPageView.apply(this, arguments);
      }

      return trackPageView;
    }()
  }, {
    key: "setUserId",
    value: function setUserId(userId) {
      this.userId = userId;
    }
  }, {
    key: "setUserProps",
    value: function () {
      var _setUserProps = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(props) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setUserProps(_x) {
        return _setUserProps.apply(this, arguments);
      }

      return setUserProps;
    }()
  }, {
    key: "setUserPropsOnce",
    value: function () {
      var _setUserPropsOnce = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(props) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function setUserPropsOnce(_x2) {
        return _setUserPropsOnce.apply(this, arguments);
      }

      return setUserPropsOnce;
    }()
  }, {
    key: "setCohortVisitParams",
    value: function () {
      var _setCohortVisitParams = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var date, weekDay, hour;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                date = new Date();
                weekDay = date.getUTCDay();
                weekDay = weekDay === 0 ? 7 : weekDay;
                hour = date.getUTCHours();
                return _context4.abrupt("return", this.setUserPropsOnce({
                  cohort_hour: hour,
                  cohort_day: getDayNumberOfYear(date),
                  cohort_week_day: weekDay,
                  cohort_week: getWeekNumber(date),
                  cohort_month: date.getMonth() + 1,
                  cohort_year: date.getFullYear(),
                  cohort_date: Number(dateToYYYYMMDD(date))
                }));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setCohortVisitParams() {
        return _setCohortVisitParams.apply(this, arguments);
      }

      return setCohortVisitParams;
    }()
  }, {
    key: "trackHoverEvent",
    value: function trackHoverEvent(element, eventName, props, triggerDelay) {
      var _this = this;

      return new _HoverTracker["default"](element, triggerDelay, /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.trackEvent(eventName, props);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
    }
  }, {
    key: "trackEvent",
    value: function () {
      var _trackEvent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(eventName, props) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function trackEvent(_x3, _x4) {
        return _trackEvent.apply(this, arguments);
      }

      return trackEvent;
    }()
  }, {
    key: "trackCharge",
    value: function () {
      var _trackCharge = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(eventName, props) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.trackEvent(eventName, props));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function trackCharge(_x5, _x6) {
        return _trackCharge.apply(this, arguments);
      }

      return trackCharge;
    }()
  }, {
    key: "trackRevenue",
    value: function () {
      var _trackRevenue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(eventName, value, props) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.trackEvent(eventName, props));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function trackRevenue(_x7, _x8, _x9) {
        return _trackRevenue.apply(this, arguments);
      }

      return trackRevenue;
    }()
  }, {
    key: "getDeviceId",
    value: function getDeviceId() {
      return this.userId;
    }
  }, {
    key: "setDebug",
    value: function setDebug(isDebug) {
      this.debug = isDebug;
    }
  }, {
    key: "log",
    value: function log() {
      if (this.debug) {
        var _console;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_console = console).log.apply(_console, ["analytics: "].concat(args));
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      if (this.debug) {
        var _console2;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        (_console2 = console).warn.apply(_console2, ["analytics: "].concat(args));
      }
    }
  }]);
  return BaseAnalytic;
}();

exports["default"] = BaseAnalytic;

function dateToYYYYMMDD(date) {
  var d = "" + date.getDate();
  var m = "" + (date.getMonth() + 1); //Month from 0 to 11

  var y = date.getFullYear();
  return '' + y + m.padStart(2, "0") + d.padStart(2, "0");
}

function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())); // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7

  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7)); // Get first day of year

  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1)); // Calculate full weeks to nearest Thursday

  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7); // Return array of year and week number

  return weekNo;
}

function getDayNumberOfYear(date) {
  var now = date;
  var start = new Date(now.getFullYear(), 0, 0);
  var diff = now - start + (start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000;
  var oneDay = 1000 * 60 * 60 * 24;
  var day = Math.floor(diff / oneDay);
  return day;
}